import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full bg-navy py-8 px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="max-w-7xl mx-auto" data-id="element-15">
          <div className="flex flex-col items-center justify-center space-y-4" data-id="element-16">
            {/* Brand */}
            <div className="text-center" data-id="element-17">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-18">
                RESET de Scroll
              </h3>
              <p className="text-gray-400 text-sm" data-id="element-19">
                Método Fricción + Reemplazo para estudiar sin el celular
              </p>
            </div>

            {/* Links */}
            <div className="flex items-center space-x-6" data-id="element-20">
              <button onClick={() => setShowPrivacy(true)} className="text-gray-400 hover:text-teal transition-colors text-sm font-medium" data-id="element-21">
                Privacidad
              </button>
              <span className="text-gray-600" data-id="element-22">•</span>
              <button onClick={() => setShowTerms(true)} className="text-gray-400 hover:text-teal transition-colors text-sm font-medium" data-id="element-23">
                Términos
              </button>
            </div>

            {/* Copyright */}
            <p className="text-gray-500 text-xs" data-id="element-24">
              © {new Date().getFullYear()} RESET de Scroll. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-25">
        <div className="prose prose-sm max-w-none" data-id="element-26">
          <p className="text-gray-700 mb-4" data-id="element-27">
            <strong data-id="element-28">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES')}
          </p>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-29">
            1. Información que recopilamos
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-30">
            Al adquirir "RESET de Scroll (7 días)", recopilamos únicamente la
            información necesaria para procesar tu compra y entregarte el
            producto digital:
          </p>
          <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-31">
            <li data-id="element-32">Nombre y dirección de correo electrónico</li>
            <li data-id="element-33">
              Información de pago (procesada de forma segura por nuestro
              proveedor de pagos)
            </li>
            <li data-id="element-34">Fecha y hora de la compra</li>
          </ul>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-35">
            2. Uso de la información
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-36">Utilizamos tu información para:</p>
          <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-37">
            <li data-id="element-38">Entregarte el PDF y las plantillas descargables</li>
            <li data-id="element-39">Enviarte actualizaciones sobre tu compra</li>
            <li data-id="element-40">Responder a tus consultas de soporte</li>
            <li data-id="element-41">Mejorar nuestro producto basándonos en feedback agregado</li>
          </ul>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-42">
            3. Protección de datos
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-43">
            Implementamos medidas de seguridad para proteger tu información
            personal. No vendemos, alquilamos ni compartimos tu información con
            terceros, excepto cuando sea necesario para procesar tu pago o
            cumplir con requisitos legales.
          </p>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-44">
            4. Tus derechos
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-45">Tienes derecho a:</p>
          <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-46">
            <li data-id="element-47">Acceder a tu información personal</li>
            <li data-id="element-48">Solicitar la corrección de datos inexactos</li>
            <li data-id="element-49">Solicitar la eliminación de tus datos</li>
            <li data-id="element-50">Retirar tu consentimiento en cualquier momento</li>
          </ul>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-51">5. Cookies</h3>
          <p className="text-gray-700 mb-4" data-id="element-52">
            Utilizamos cookies esenciales para el funcionamiento del sitio web.
            No utilizamos cookies de seguimiento o publicidad.
          </p>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-53">
            6. Cambios a esta política
          </h3>
          <p className="text-gray-700" data-id="element-54">
            Nos reservamos el derecho de actualizar esta política de privacidad
            en cualquier momento. Los cambios entrarán en vigor inmediatamente
            después de su publicación en esta página.
          </p>
        </div>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-55">
        <div className="prose prose-sm max-w-none" data-id="element-56">
          <p className="text-gray-700 mb-4" data-id="element-57">
            <strong data-id="element-58">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES')}
          </p>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-59">
            1. Aceptación de términos
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-60">
            Al comprar "RESET de Scroll (7 días)", aceptas estos términos y
            condiciones. Si no estás de acuerdo, por favor no realices la
            compra.
          </p>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-61">
            2. Descripción del producto
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-62">
            "RESET de Scroll (7 días)" es un producto digital (PDF) que incluye:
          </p>
          <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-63">
            <li data-id="element-64">Guía completa del método Fricción + Reemplazo</li>
            <li data-id="element-65">Plan de 7 días paso a paso</li>
            <li data-id="element-66">
              Plantillas imprimibles (tracker, checklist, lista de reemplazos)
            </li>
            <li data-id="element-67">Protocolo 3-7-15 para recaídas</li>
          </ul>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-68">
            3. Precio y pago
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-69">
            El precio del producto es de $10 USD (pago único). El pago se
            procesa de forma segura a través de nuestro proveedor de pagos. Una
            vez completado el pago, recibirás acceso inmediato al producto
            digital.
          </p>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-70">
            4. Entrega del producto
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-71">
            El producto se entrega de forma digital inmediatamente después de
            completar la compra. Recibirás un correo electrónico con el enlace
            de descarga del PDF y las plantillas.
          </p>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-72">
            5. Micro-garantía
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-73">
            Si aplicas el método durante 7 días completos y sientes que no
            obtuviste ninguna mejora medible, te quedas con las plantillas y el
            protocolo de emergencia para usar en exámenes. No ofrecemos
            reembolsos monetarios, pero garantizamos que el material tiene valor
            práctico.
          </p>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-74">
            6. Uso del producto
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-75">
            Este producto es para uso personal únicamente. No está permitido:
          </p>
          <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-76">
            <li data-id="element-77">Revender o redistribuir el contenido</li>
            <li data-id="element-78">Compartir el PDF o las plantillas públicamente</li>
            <li data-id="element-79">Modificar el contenido y presentarlo como propio</li>
            <li data-id="element-80">Usar el material con fines comerciales sin autorización</li>
          </ul>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-81">
            7. Limitación de responsabilidad
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-82">
            Este producto ofrece estrategias y técnicas prácticas, pero no
            sustituye tratamiento médico o terapia profesional. Los resultados
            pueden variar según cada persona. No nos hacemos responsables de
            resultados específicos.
          </p>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-83">
            8. Propiedad intelectual
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-84">
            Todo el contenido de "RESET de Scroll (7 días)" está protegido por
            derechos de autor. Al comprar, obtienes una licencia de uso
            personal, no la propiedad del contenido.
          </p>

          <h3 className="text-lg font-bold text-navy mt-6 mb-3" data-id="element-85">
            9. Modificaciones
          </h3>
          <p className="text-gray-700" data-id="element-86">
            Nos reservamos el derecho de actualizar estos términos en cualquier
            momento. Las modificaciones entrarán en vigor inmediatamente después
            de su publicación.
          </p>
        </div>
      </Modal>
    </>;
}